export default __webpack_public_path__ + "static/media/taking_notes.31451b73.svg";